import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

const ChallengeClosed = ({ ownerChallenge }: NotificationContentProps) => {
  return (
    <Trans
      i18nKey="notifications.challengeClosed"
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
      components={{ b: <b /> }}
    />
  );
};

export default ChallengeClosed;
